<template>
  <div class="error404">
    <div>
      <h3>404!页面找不到</h3>
      <p class="back">
        <span>返回</span>
        <span @click="toHome"> 首页 </span>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'error_404',
    methods: {
      toHome () {
        this.$router.push('/');
      }
    }
  };
</script>

<style lang="scss">
  .error404 {
    > div {
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      font-style: italic;
      margin-top: 200px;
    }
    
    .back {
      margin-top: 20px;
      font-size: 14px;
      
      span:last-child {
        cursor: pointer;
        color: #4A78FF;
      }
    }
  }
</style>
